export default {"src":"/_next/static/media/celery.8b55dd70.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};